module.exports = __webpack_public_path__ + "img/playWhite.794eadab.svg";